import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { ComponentConsumerProps, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { JSONLDSeoModel } from './model/jsonldSeoTags.models';
import { TJSONLDSeoTagsProps } from './types/jsonldSeoTags.types';

const JSONLDSeoTag: FC<TJSONLDSeoTagsProps & ComponentConsumerProps> = (props) => {
  const model = new JSONLDSeoModel(props);

  return (
    <>
      <Helmet script={[model.pageJSONLD]} />
      {model.homePage && model.hostUrl && model?.searchUrl && (
        <Helmet script={[model.searchboxJSONLD]} />
      )}
    </>
  );
};

export default withSitecoreContext()(JSONLDSeoTag);
